"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function getMonthlyExpenses() {
  var expense = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keyMap = {
    // Property - 4 (_1 for q.4 and _2 for q.20)
    propertyExpenses: [],
    // Utilities - 6
    electricityGasHeat: ['electric', 'heat'],
    waterSewageTrash: ['waterSewerTrash'],
    phoneCellInternet: ['cablePhoneInternet', 'cellPhone'],
    otherUtilities: ['otherUtilities'],
    // - 6D. Compiled
    foodHouseSupplies: ['groceries'],
    // - 7
    childcare: ['daycareBabysitter', 'childEducation'],
    // - 8
    clothing: ['clothing', 'cleaningLaundry'],
    // - 9
    personalCare: ['personalCare'],
    // - 10
    medicalDental: ['medicalExpenses', 'medicalPrescriptions', 'dentalExpenses', 'dentalPrescriptions', 'visionExpenses', 'glasses', 'contacts'],
    // - 11
    transportation: ['gasoline', 'vehicleMaintenance', 'otherTransportation'],
    // - 12
    recreation: ['recreation'],
    // - 13
    charity: ['charity'],
    // - 14
    // Insurance - 15
    lifeInsurance: ['lifeInsurance'],
    healthInsurance: ['healthInsurance'],
    // Medical, Dental, Vision
    vehicleInsurance: ['vehicleInsurance'],
    otherInsurance: ['otherInsurance'],
    // - 15D. Compiled
    taxPayments: ['taxPayments'],
    // { // - 16. Compiled
    // - 17. Ignore A/B. Start at other. Past 2 entries, we need to overflow
    installmentPayments: ['installmentPayments'],
    // [{ name: null, value: 0 }]
    otherAlimony: ['childSupportAlimony', 'otherAlimony'],
    // 18
    contributionsToFamily: ['contributionsToFamily'],
    // 19
    // 21
    others: ['others']
  };
  var monthlyExpenses = 0; // Try to find slot for each of our expense keys

  Object.keys(keyMap).forEach(function (mapKey) {
    Object.keys(expense).forEach(function (exKey) {
      if (mapKey === 'installmentPayments' && exKey === 'installmentPayments') {
        if (expense[exKey] != null && Array.isArray(expense[exKey])) {
          Array.prototype.forEach.call(expense[exKey].filter(function (p) {
            return p != null;
          }), function (prop) {
            monthlyExpenses += Number(prop.value || 0);
          });
        }
      } else if (mapKey === 'propertyExpenses' && exKey === 'propertyExpenses') {
        if (expense[exKey] != null && Array.isArray(expense[exKey])) {
          Array.prototype.forEach.call(expense[exKey].filter(function (p) {
            return p != null;
          }), function (prop) {
            monthlyExpenses += Number(prop.mortgageRent || 0) + Number(prop.propertyTaxes || 0) + Number(prop.propertyInsurance || 0) + Number(prop.upkeepRepairs || 0) + Number(prop.hoaCondoFees || 0) + Number(prop.additionalPayments || 0);
          });
        }
      } else if (keyMap[mapKey].indexOf(exKey) !== -1) {
        if (!isNaN(expense[exKey])) {
          monthlyExpenses += Number(expense[exKey]) || 0;
        } else if (expense[exKey] && !isNaN(expense[exKey].value)) {
          monthlyExpenses += Number(expense[exKey].value) || 0;
        } else if (expense[exKey].length && expense[exKey].length > 0) {
          monthlyExpenses += expense[exKey].reduce(function (accum, o) {
            return accum += Number(o.value) || 0;
          }, 0);
        }
      }
    });
  });
  return monthlyExpenses;
}

var _default = getMonthlyExpenses;
exports["default"] = _default;